<template>
    <div id="LeftBaseView">
        <div class="row">
          <div class="col-12">
             <MdTitleRegInfo
              v-bind:RegistrationInfo="PatientTitle"
              v-bind:titlePrefix="MdTitle"
              v-bind:IsClinical="false"
              v-bind:patientCode="PatientCode">
            </MdTitleRegInfo>
          </div>
        </div>

        <slot name="content"></slot>
    </div>
</template>

<script>

export default {
  name: 'LeftBaseView',
    inject: ['onHideMenu'],
  props:{
    MdTitle:String,
    PatientCode:String,
    HideRightMenu:Boolean
  },

  components:{},
  data(){
    return {
        PatientTitle:{
       programName:'',
       fullName:'',
       admitDate:'',
       dischargeDate:'',
       dob:'',
       activitytypename:'',
       startdatetime:'',
       ageFormatted:''
     },
         OptionsRightMenu:{
            visible:false,
            btnCNContainervisible:false,
            btnGroupNotesvisible:false,
            btnDrugOrdersInboxvisible:false,
            btnPatientsPortalDashboardVisible:false,
            btnIncidentWorkflowvisible:false,
            btnvisible:false,
            ItemsList:[],
            favButtonAtion: false
        },
    }
  },

  computed:{

  },

  methods:{
    HideRightBar(){
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        this.$emit('onMenuRightBarGroupNotes', this.OptionsRightMenu);
        this.$emit('onMenuRightBarCNContainer', this.OptionsRightMenu);
        this.$emit('onMenuRightBarIncidentWorkflow', this.OptionsRightMenu);
        this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);
        this.$emit('onMenuRightBarPatientsPortalDashboard', this.OptionsRightMenu);
    },
  },

  created(){

  },

  mounted(){
    this.HideRightBar();
  }

};
</script>


